<template>
  <i-dx-popup
    :popupVisible="popupVisible"
    :title="title"
    @popupCloseButtonClick="closeBtn"
    @showing="onPopup"
    height="100vh"
    width="80vw"
  >
    <template v-slot:grid>
      <div class="v-application" style="display: block !important; ">
        <v-row no-gutters class="px-6">
          <v-col cols="4" class="pr-2 d-flex flex-column" height="100%">
            <v-card width="100%" color="inner_card_bg" flat class="py-3 px-4 rounded">
              <div class="card-sub-title">현재 적용된 양식</div>
              <div class="card-title">{{ currntDiv && currntDiv.dataDivNm }}</div>
              <div class="card-title-code">{{ currntDiv && currntDiv.dataDiv }}</div>
            </v-card>
            <v-card
              color="inner_card_bg"
              flat
              height="calc(100vh - 268px)"
              class="pa-4 mt-2 rounded overflow-y-auto"
            >
              <v-list class="popup-card-list">
                <v-list-item-group v-model="selectedIndex" mandatory color="primary">
                  <v-list-item
                    v-for="(item, index) in dataDivList"
                    :key="index"
                    :class="{ selected: index === selectedIndex }"
                    outlined
                  >
                    <v-list-item-content>
                      <v-text-field
                        dense
                        hide-details="auto"
                        solo
                        spellcheck="false"
                        :disabled="item.clntId == 'COMMON'"
                        v-model="item.dataDivNm"
                      ></v-text-field>
                      <v-list-item-subtitle>{{ item.dataDiv }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="ml-2">
                      <v-btn
                        color="primary"
                        elevation="0"
                        small
                        :outlined="!(item.clntId != 'COMMON' && item.finalUse == 'Y') || (item.clntId == 'COMMON' && basicApplyFlag)"
                        height="30px"
                        class="rounded"
                        :disabled="(item.clntId != 'COMMON' && item.finalUse == 'Y') || (item.clntId == 'COMMON' && basicApplyFlag)"
                        @click="btnDivApply(item)"
                      >
                        <span>
                          {{
                          (item.clntId != 'COMMON' && item.finalUse == 'Y') || (item.clntId == 'COMMON' && basicApplyFlag) ? '적용중' : '적용'
                          }}
                        </span>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
            <div class="btn-wrap mt-2">
              <v-btn
                color="error"
                elevation="0"
                large
                outlined
                class="rounded"
                :disabled="btnDisabled"
                @click="btnDivDelete()"
              >
                <span>삭제</span>
              </v-btn>
              <v-btn
                color="primary"
                elevation="0"
                large
                outlined
                class="rounded"
                @click="btnDivAdd()"
              >
                <span>추가</span>
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <!-- <v-icon small color="primary" style="position: absolute; right: 5px;" v-on="on">mdi-information-outline</v-icon> -->
                    <svg-icon
                      icon-class="info"
                      style="height: 1rem; position: absolute; right: 5px;"
                      v-on="on"
                    />
                  </template>
                  <div class="tooltip-text">{{ '빈 양식을 생성하여 사용자가 항목을 설정합니다.' }}</div>
                </v-tooltip>
              </v-btn>
              <v-btn
                color="primary"
                elevation="0"
                large
                outlined
                class="rounded"
                :disabled="!selectedDiv"
                @click="btnDivCopy()"
              >
                <span>복사</span>
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on }">
                    <!-- <v-icon small color="primary" style="position: absolute; right: 5px;" v-on="on">mdi-information-outline</v-icon> -->
                    <svg-icon
                      icon-class="info"
                      style="height: 1rem; position: absolute; right: 5px;"
                      v-on="on"
                    />
                  </template>
                  <div class="tooltip-text">{{ '현재 선택된 양식을 복사하여 추가/수정/삭제하여 사용합니다.' }}</div>
                </v-tooltip>
              </v-btn>
              <v-btn
                color="primary"
                elevation="0"
                large
                outlined
                class="rounded"
                :disabled="btnDisabled"
                @click="btnDivSave()"
              >
                <span>저장</span>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="8" class="pl-2">
            <!--i-card-vertical headerTitle="직책 구분" device="web" :IsUseInnerAddition="true" :onlyGrid="true" contentsClass="popup-grid-card">
              <template v-slot:innerAddition>
                <div class="btn-wrap ml-2">
                  <v-btn color="error" elevation="0" large outlined class="rounded" :disabled="btnDisabled" @click="btnMainDelete()">
                    <span>삭제</span>
                  </v-btn>
                  <v-btn color="primary" elevation="0" large outlined class="rounded" :disabled="btnDisabled" @click="btnMainAdd()">
                    <span>추가</span>
                  </v-btn>
                  <v-btn color="primary" elevation="0" large outlined class="rounded" :disabled="btnDisabled" @click="btnMainSave()">
                    <span>저장</span>
                  </v-btn>
                </div>
              </template>
            <template v-slot:body-->
            <DxDataGrid
              key-expr="id"
              width="100%"
              height="calc((100vh - 260px)/2)"
              :ref="dxDataGridMainRef"
              :data-source="gridMain"
              :focused-row-enabled="true"
              :focused-row-index.sync="focusedRowIndexMain"
              :hover-state-enabled="true"
              :allow-column-resizing="true"
              :column-auto-width="false"
              :show-borders="true"
              :show-row-lines="true"
              :selection="{ showCheckBoxesMode:'none' }"
              :pager="{visible:''}"
              @focused-row-changed="onFocusedRowChanged"
              @editor-preparing="
                e => {
                  onEditorPreparing(e)
                  onEditorPreparingExtra(e)
                }
              "
            >
              <DxColumn data-field="clntId" data-type="string" :visible="false" />
              <DxColumn data-field="compId" data-type="string" :visible="false" />
              <DxColumn data-field="dataDiv" data-type="string" :visible="false" />
              <DxColumn
                data-field="authDiv"
                data-type="string"
                caption="관리 직책 구분"
                css-class="devest-grid-header-require"
              >
                <DxLookup :data-source="authList" value-expr="grpAuthCd" display-expr="grpAuthNm" />
              </DxColumn>
            </DxDataGrid>
            <!--/template>
            </i-card-vertical-->
            <i-card-vertical
              headerTitle="담당업무 구분"
              device="web"
              :IsUseInnerAddition="true"
              :onlyGrid="true"
              contentsClass="pa-0"
              class="mt-5"
            >
              <template v-slot:innerAddition>
                <div class="btn-wrap ml-2">
                  <v-btn
                    color="error"
                    elevation="0"
                    large
                    outlined
                    class="rounded"
                    :disabled="btnDisabledDetail"
                    @click="btnDetailDelete()"
                  >
                    <span>삭제</span>
                  </v-btn>
                  <v-btn
                    color="primary"
                    elevation="0"
                    large
                    outlined
                    class="rounded"
                    :disabled="btnDisabledDetail"
                    @click="btnDetailAdd()"
                  >
                    <span>추가</span>
                  </v-btn>
                  <v-btn
                    color="primary"
                    elevation="0"
                    large
                    outlined
                    class="rounded"
                    :disabled="btnDisabledDetail"
                    @click="btnDetailSave()"
                  >
                    <span>저장</span>
                  </v-btn>
                </div>
              </template>

              <template v-slot:body>
                <DxDataGrid
                  key-expr="id"
                  width="100%"
                  height="calc((100vh - 180px)/2)"
                  :ref="dxDataGridDetailRef"
                  :data-source="gridDetail"
                  :focused-row-enabled="true"
                  :focused-row-index.sync="focusedRowIndexDetail"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :column-auto-width="false"
                  :show-borders="true"
                  :show-row-lines="true"
                  @editor-preparing="
                    e => {
                      onEditorPreparing(e)
                    }
                  "
                >
                  <DxEditing
                    mode="batch"
                    :allow-updating="!btnDisabled"
                    :select-text-on-edit-start="true"
                  />
                  <DxColumn data-field="clntId" data-type="string" :visible="false" />
                  <DxColumn data-field="compId" data-type="string" :visible="false" />
                  <DxColumn data-field="dataDiv" data-type="string" :visible="false" />
                  <DxColumn data-field="authDiv" data-type="string" :visible="false" />
                  <DxColumn data-field="authDivItem" data-type="string" :visible="false" />
                  <DxColumn
                    data-field="authDivItemNm"
                    data-type="string"
                    caption="담당업무"
                    css-class="devest-grid-header-require"
                  ></DxColumn>
                </DxDataGrid>
              </template>
            </i-card-vertical>
          </v-col>
        </v-row>
      </div>
    </template>
  </i-dx-popup>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import IDxPopup from '@/components/common/iDxPopup.vue'
import { getGroupData } from '@/api/setting/groupManage'
import {
  getSafetyManagerManageDataDiv,
  addSafetyManagerManageDataDiv,
  applySafetyManagerManageDataDiv,
  copySafetyManagerManageDataDiv,
  saveSafetyManagerManageDataDiv,
  deleteSafetyManagerManageDataDiv,
  saveSafetyManagerManageAuthDiv,
  deleteSafetyManagerManageAuthDiv,
  getSafetyManagerManageAuthDivItem,
  saveSafetyManagerManageAuthDivItem,
  deleteSafetyManagerManageAuthDivItem
} from '@/api/evaluationImprovement/safetyManagerManage.js'
export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    IDxPopup
  },
  props: {
    popupVisible: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      dataDivList: [],
      selectedIndex: null,
      dxDataGridMainRef: 'dataDivMain',
      dxDataGridDetailRef: 'dataDivDetail',
      gridMain: [],
      focusedRowIndexMain: -1,
      focusedRowDataMain: null,
      gridDetail: [],
      focusedRowIndexDetail: -1,
      authList: []
    }
  },
  computed: {
    selectedDiv() {
      return this.dataDivList.length && Number.isInteger(this.selectedIndex) ? this.dataDivList[this.selectedIndex] : null
    },
    btnDisabled() {
      return !this.selectedDiv || this.selectedDiv.clntId == 'COMMON'
    },
    btnDisabledDetail() {
      return this.btnDisabled || !this.focusedRowDataMain || this.focusedRowDataMain.__created__
    },
    currntDiv() {
      return this.dataDivList.length && this.dataDivList.findLast(e => e.finalUse == 'Y')
    },
    // 기본항목 적용/적용중 플래그값 생성
    basicApplyFlag() {
      return !this.dataDivList.some(el => el.clntId != 'COMMON' && el.finalUse == 'Y')
    }
  },
  watch: {
    selectedIndex: function(index) {
      this.gridInit(this.GetDataGrid(this.dxDataGridMainRef))
      this.focusedRowIndexMain = -1
      this.focusedRowIndexDetail = -1
      if (Number.isInteger(index)) {
        this.gridMain = this.dataDivList[index].authDivList.slice()
      } else {
        this.gridMain = []
      }
    }
  },
  beforeMount() {
    Promise.all([getGroupData()]).then(response => {
      let failedResponse = response.find(element => !element.success)
      if (failedResponse == null) {
        this.authList = response[0].list.filter(auth => auth.clientYn == 'Y')
        // grpAuthCd, grpAuthNm
      } else {
        this.$vToastify.error({ body: failedResponse.msg })
        this.vToastify(failedResponse.msg, 'error')
      }
    })
  },
  methods: {
    onPopup(e) {
      this.searchDataDiv(true)
    },
    searchDataDiv(isNotify) {
      this.selectedIndex = null
      this.dataDivList = []
      this.openLoading('searching')
      getSafetyManagerManageDataDiv(
        {
          clntId: this.getClntId(),
          compId: this.getCompId()
        },
        isNotify
      )
        .then(res => {
          this.dataDivList = res.list
          console.log(this.dataDivList)
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnDivAdd() {
      this.openLoading('saving')
      addSafetyManagerManageDataDiv(
        {
          clntId: this.getClntId(),
          compId: this.getCompId(),
          createdBy: this.getUserCd()
        },
        false
      )
        .then(response => {
          this.selectedIndex = null
          this.dataDivList = response.list
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnDivCopy() {
      this.openLoading('saving')
      copySafetyManagerManageDataDiv(
        {
          clntId: this.getClntId(),
          compId: this.getCompId(),
          clntIdCopy: this.selectedDiv.clntId,
          compIdCopy: this.selectedDiv.compId,
          dataDivCopy: this.selectedDiv.dataDiv,
          createdBy: this.getUserCd()
        },
        false
      )
        .then(response => {
          this.selectedIndex = null
          this.dataDivList = response.list
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnDivSave() {
      this.openLoading('saving')
      saveSafetyManagerManageDataDiv(
        {
          clntId: this.selectedDiv.clntId,
          compId: this.selectedDiv.compId,
          dataDiv: this.selectedDiv.dataDiv,
          dataDivNm: this.selectedDiv.dataDivNm,
          createdBy: this.getUserCd()
        },
        false
      )
        .then(response => {
          this.selectedIndex = null
          this.dataDivList = response.list
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnDivDelete() {
      this.openLoading('deleting')
      deleteSafetyManagerManageDataDiv(
        {
          clntId: this.selectedDiv.clntId,
          compId: this.selectedDiv.compId,
          dataDiv: this.selectedDiv.dataDiv,
          createdBy: this.getUserCd()
        },
        true
      )
        .then(response => {
          this.selectedIndex = null
          this.dataDivList = response.list
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnDivApply(div) {
      this.openLoading('saving')
      applySafetyManagerManageDataDiv(
        {
          clntId: this.getClntId(),
          compId: this.getCompId(),
          dataDiv: div.clntId == 'COMMON' ? 'COMMON' : div.dataDiv
        },
        false
      )
        .then(response => {
          this.selectedIndex = null
          this.dataDivList = response.list
        })
        .finally(() => {
          this.endLoading()
        })
    },
    btnMainAdd() {
      let newRow = {
        id: this.gridMain.length + 1,
        clntId: this.getClntId(),
        compId: this.getCompId(),
        dataDiv: this.selectedDiv.dataDiv,
        createdBy: this.getUserCd(),
        __created__: true
      }
      this.focusedRowIndexMain = -1
      this.GetDataGrid(this.dxDataGridMainRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridMainRef).selectRows(newRow.id, true)
    },
    async btnMainSave() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridMainRef).getSelectedRowsData()
      if (!selectedRows.length) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      this.GetDataGrid(this.dxDataGridMainRef).saveEditData()

      if (selectedRows.findIndex(element => !element.authDiv) > -1) {
        this.vToastify(this.$t('필수항목 입력하세요.[관리 직책 구분]'), 'info')
        return
      }

      var authDivSet = new Set(this.gridMain.map(e => e.authDiv))
      if (authDivSet.size < this.gridMain.length) {
        this.vToastify(this.$t('중복된 항목이 있습니다.[관리 직책 구분]'), 'info')
        return
      }
      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridMainRef).beginUpdate()
          this.openLoading('saving')
          saveSafetyManagerManageAuthDiv(
            selectedRows.filter(element => element.__created__),
            true
          )
            .then(res => {
              this.searchDataDiv(false)
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridMainRef).endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    async btnMainDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridMainRef).getSelectedRowsData()
      if (!selectedRows.length) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      this.GetDataGrid(this.dxDataGridMainRef).saveEditData()
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridMainRef).beginUpdate()
          this.openLoading('deleting')
          deleteSafetyManagerManageAuthDiv(
            selectedRows
              .filter(element => !element.__created__)
              .map(e => {
                e.createdBy = this.getUserCd()
                return e
              }),
            true
          )
            .then(res => {
              this.searchDataDiv(false)
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridMainRef).endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },

    btnDetailAdd() {
      let newRow = {
        id: this.gridDetail.length + 1,
        clntId: this.getClntId(),
        compId: this.getCompId(),
        dataDiv: this.focusedRowDataMain.dataDiv,
        authDiv: this.focusedRowDataMain.authDiv,
        createdBy: this.getUserCd(),
        __created__: true
      }

      this.GetDataGrid(this.dxDataGridDetailRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridDetailRef).selectRows(newRow.id, true)
    },

    async btnDetailSave() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridDetailRef).getSelectedRowsData()
      if (!selectedRows.length) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      this.GetDataGrid(this.dxDataGridDetailRef).saveEditData()

      if (selectedRows.findIndex(element => !element.authDivItemNm) > -1) {
        this.vToastify(this.$t('필수항목 입력하세요.[담당업무]'), 'info')
        return
      }

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridDetailRef).beginUpdate()
          this.openLoading('saving')
          saveSafetyManagerManageAuthDivItem(
            selectedRows.map(e => {
              e.createdBy = this.getUserCd()
              return e
            }),
            true
          )
            .then(res => {
              this.getDetail(false)
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridDetailRef).endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    getDetail(isNotify) {
      getSafetyManagerManageAuthDivItem(this.focusedRowDataMain, isNotify)
        .then(res => {
          this.gridInit(this.GetDataGrid(this.dxDataGridDetailRef))
          this.gridDetail = res.list
          this.focusedRowIndexDetail = this.gridDetail.length ? 0 : -1
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnDetailDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridDetailRef).getSelectedRowsData()
      if (!selectedRows.length) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      this.GetDataGrid(this.dxDataGridDetailRef).saveEditData()
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridDetailRef).beginUpdate()
          this.openLoading('deleting')
          deleteSafetyManagerManageAuthDivItem(
            selectedRows
              .filter(element => !element.__created__)
              .map(e => {
                e.createdBy = this.getUserCd()
                return e
              }),
            true
          )
            .then(res => {
              this.getDetail(false)
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridDetailRef).endUpdate()
              this.endLoading()
            })
        },
        null,
        true
      )
    },

    closeBtn() {
      this.$emit('popupClose')
    },
    ///////////////////////////////////////
    /*         DataGrid   Event          */
    ///////////////////////////////////////
    onEditorPreparingExtra(e) {
      if (e.parentType == 'dataRow') {
        switch (e.dataField) {
          case 'authDiv':
            e.editorOptions.readOnly = !e.row.data.__created__
            break
          default:
            break
        }
      }
    },
    onFocusedRowChanged(e) {
      this.focusedRowDataMain = e.row && e.row.data
      if (this.focusedRowDataMain && !this.focusedRowDataMain.__created__) {
        this.getDetail(true)
      } else {
        this.gridDetail = []
        this.focusedRowIndexDetail = -1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-wrap {
  display: flex;
  gap: 8px;
  .v-btn {
    flex: 1 0 auto;
    min-width: unset;
    padding: 0 4px;
  }
  &.ml-2 {
    .v-btn {
      padding: 0 8px;
    }
  }
}
.card-sub-title {
  color: #3e3e3f;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: normal;
}
.card-title {
  font-size: 1.125rem;
  font-weight: 400;
  line-height: normal;
  padding: 16px 0 4px;
}
.card-title-code {
  color: #babbbb;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
